export const baseUrl = process.env.REACT_APP_API_BASE_URL
export const baseUrlVoice = process.env.REACT_APP_API_VOICE_BASE_URL
export const baseUrlVoiceImage = process.env.REACT_APP_API_VOICE_IMAGE_BASE_URL
